'use es6';

import { Map as ImmutableMap } from 'immutable';
import { createContext } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import PropTypes from 'prop-types';
import emptyFunction from 'react-utils/emptyFunction';
const defaultValue = {
  data: ImmutableMap(),
  fetch: emptyFunction
};
const DSContext = /*#__PURE__*/createContext(defaultValue);
export default {
  Consumer: DSContext.Consumer,
  Provider: DSContext.Provider,
  propTypes: {
    DSContext: PropTypes.shape({
      data: ImmutablePropTypes.map.isRequired,
      fetch: PropTypes.func
    })
  }
};